export const ESearchScope = {
  ALL: 'ALL',
  ALL_FAVORITES: 'ALL_FAVORITES',

  WORKSPACE: 'WORKSPACE',
  WORKSPACE_FAVORITES: 'WORKSPACE_FAVORITES',
};
